import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Flex, Paragraph } from '@cof/plastic-components';

import TitleSection, { TitleSectionHeading } from '../../components/TitleSection';
import { withText } from '../../text/textStore';
import pushToDataLayer, { EVENTS } from '../../utilities/dataLayer/dataLayer';
import useTimeout from '../../hooks/useTimeout/useTimeout';
import { css, styled } from 'styled-components';
import Main from '../../components/Main';
import Header from '../../components/Header/Header';
import BodySection from '../../components/BodySection';

export const TimeoutTitleSection = styled(TitleSection)`
    ${({ theme }: any) => css`
        ${theme.components.HeroWrapper}
        text-align: center;
    `}
`;
TimeoutTitleSection.displayName = 'TimeoutTitleSection';

const TimedOut = ({ Text, children }: any) => {
    const timedOut = useTimeout();
    useEffect(() => {
        if (timedOut) {
            pushToDataLayer({
                event: EVENTS.EXPIRY_PAGE_SHOW
            });
        }
    }, [timedOut]);
    return timedOut ? (
        <>
            <Header isDeclinePage={true} />
            <Main bg="global.white">
                <TimeoutTitleSection data-qm-visible>
                    <TitleSectionHeading data-qa-id="timeout-heading" data-qm-allow>
                        <Text path="Title" />
                    </TitleSectionHeading>
                </TimeoutTitleSection>
                <BodySection textAlign={['left', null, 'center']} data-qm-visible>
                    <Paragraph pb={['sm', 'md', 'lg']} data-qm-allow>
                        <Text path="Paragraph1" />
                    </Paragraph>
                    <Paragraph pb={['md', 'lg', 'xl']} data-qm-allow>
                        <Text path="Paragraph2" />
                    </Paragraph>
                    <Flex justifyContent="center">
                        <Button as="a" href="/" data-qm-allow>
                            <Text path="Button.Text" />
                        </Button>
                    </Flex>
                </BodySection>
            </Main>
        </>
    ) : (
        children
    );
};

TimedOut.propTypes = {
    Text: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

const TimedOutWithText = withText(`TimedOut`)(TimedOut);

TimedOutWithText.displayName = 'TimedOut';

export default TimedOutWithText;
